import { createEnv } from "@t3-oss/env-core"
import * as v from "valibot"

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    // Host configuration
    VITE_HOST: v.string(),
    VITE_PORT: v.optional(v.string()),
    VITE_ROBOTS: v.string(),
    VITE_SOURCEMAPS: v.string(),
    VITE_DOMAIN: v.string(),

    // Header/Footer
    VITE_HF_CDN_URL: v.string(),
    VITE_HF_CDN_ENV: v.string(),

    // Authentication
    VITE_AUTH_DOMAIN: v.string(),
    VITE_AUTH_CLIENT_ID: v.string(),

    // Application Settings
    VITE_NAME: v.string(),
    VITE_API2_URL: v.string(),
    VITE_API_MEDIA_URL: v.string(),

    // Analytics & Tracking
    VITE_GTM_ID: v.string(),
    VITE_SEGMENT_SCRIPT: v.string(),
    VITE_SEGMENT_TOKEN: v.string(),

    // External URLs
    VITE_STORE: v.string(),
    VITE_ID_URL: v.string(),
    VITE_CLOUD_URL: v.string(),
    VITE_CDN: v.string(),
    VITE_DOCS: v.string(),
    VITE_TEMPLATE_URL: v.string(),

    // Other
    VITE_COOKIES_DOMAIN: v.string(),
    VITE_CHROME_EXTENSION_ID: v.string(),
    VITE_BOARDS_EDGE_URL: v.string(),

    // Code formatting API
    VITE_CODE_FORMATTER_URL: v.string()
  },

  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true
})
